module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step2_Image7a.59db463c.webp";